import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Table from "../common/Table";
import PageHeader from "../common/PageHeader";
import  fetchData  from "../../api/fetchApi";
import DatePickerModal from "../common/DatePickerModal";

export default function UserManagementPage() {
  const dir = "rtl";
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);
  const [dateRange, setDateRange] = useState({ from: "يناير 2025", to: "يونيو 2025" });

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const res = await fetchData(`admin/clients?page=${currentPage}&per_page=${perPage}`);
        const data = Array.isArray(res) ? res[0] : res;
        setUsers(data.clients || []);
        setTotalUsers(data.total || 0);
        setCurrentPage(data.current_page || 1);
        setTotalPages(data.pages || 1);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };

    fetchUsers();
  }, [currentPage, perPage]);

  function getPages(current, last) {
    if (last <= 3) return Array.from({ length: last }, (_, i) => i + 1);
    if (current === 1) return [1, 2, 3];
    if (current === last) return [last - 2, last - 1, last];
    return [current - 1, current, current + 1];
  }

  const columns = useMemo(() => [
    { header: "الاسم", accessor: "name", className: "p-3" },
    { header: "رقم الهاتف", accessor: "phone" },
    { 
      header: "نوع الباقة", 
      accessor: "package_name",
      render: (row) => row.package_name || <span className="text-gray-500">لا يوجد اشتراك</span>
    },
    {
      header: "رقم الفاتورة",
      accessor:"package_payment",

    },
    {
      header: "تاريخ الاشتراك",
      accessor: "package_start_date",
      render: (row) => {
        if (!row.package_start_date) return '-';
        const date = new Date(row.package_start_date);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}/${month}/${day}`;
      }
    },
    {
      header: "حالة الاشتراك",
      accessor: "package_status",
      render: (row) => {
        if (!row.package_status) {
          return <span className="inline-flex items-center justify-center w-28 py-1 rounded-md text-sm font-medium border bg-gray-100 text-gray-600 border-gray-200">لا يوجد اشتراك</span>;
        }
        
        const isActive = row.package_status === "active";

        return (
          <span className={`inline-flex items-center justify-center gap-2 w-28 py-1 rounded-md text-sm font-medium border ${
            isActive
              ? "bg-white text-green-700 border-gray-200"
              : "bg-white text-orange-500 border-orange-500"
          }`}>
            <span className={`h-2 w-2 rounded-full ${
              isActive ? "bg-green-500" : "bg-orange-500"
            }`}></span>
            <span>{isActive ? 'الاشتراك فعال' : 'انتهى الاشتراك'}</span>
          </span>
        );
      }
    },
    
  ], []);

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir={dir}>
      <DatePickerModal isOpen={isDatePickerOpen} onClose={() => setDatePickerOpen(false)} />
      {/* Top card: actions + total */}
         <PageHeader title="إجمالي المستخدمين"
          total={totalUsers} stats={[]}>
               <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                    <span className="inline-block rotate-180">↕</span>
                    من الاحدث إلى الأقدم
                  </button>
                  <button onClick={() => setDatePickerOpen(true)} className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <rect
                        x="3"
                        y="4"
                        width="18"
                        height="18"
                        rx="2"
                        stroke="#6b7280"
                      />
                      <line x1="8" y1="2" x2="8" y2="6" stroke="#6b7280" />
                      <line x1="16" y1="2" x2="16" y2="6" stroke="#6b7280" />
                      <line x1="3" y1="10" x2="21" y2="10" stroke="#6b7280" />
                    </svg>
                    {dateRange.from} · {dateRange.to}
                  </button>
                  <button 
                    onClick={() => navigate('/admin/users/new')}
                   className="px-4 py-2.5 rounded-lg text-white bg-[var(--Primary-Primary)] shadow-sm text-sm md:text-base">
                    إضافة مستخدم جديد
                  </button>
                </PageHeader  >


      {/* Table card */}
      <div className="mt-5">
        <Table
          columns={columns}
          rows={users}
          actions={[{ label: "عرض الكل" }]}
          pagination={{
            title: "المشتركين",
            label: `الصفحة ${currentPage} من ${totalPages}`,
            pages: getPages(currentPage, totalPages),
            current: currentPage,
            last: totalPages,
            onPageChange: setCurrentPage,
            perPage: perPage,
            onPerPageChange: setPerPage,
           
            // onRowClick: (row) => navigate(`/admin/users/${row.uuid}`),
            // onEdit, onStopPublish, onDelete can be passed here for row actions
          }}
          act= {[{
              label: <div className="flex items-center gap-2">
             <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.33341 2.66646H4.80008C4.05334 2.66646 3.67998 2.66646 3.39476 2.81179C3.14388 2.93962 2.9399 3.14359 2.81207 3.39448C2.66675 3.67969 2.66675 4.05306 2.66675 4.7998V11.1998C2.66675 11.9465 2.66675 12.3199 2.81207 12.6051C2.9399 12.856 3.14388 13.06 3.39476 13.1878C3.67998 13.3331 4.05334 13.3331 4.80008 13.3331H11.2001C11.9468 13.3331 12.3202 13.3331 12.6054 13.1878C12.8563 13.06 13.0603 12.856 13.1881 12.6051C13.3334 12.3199 13.3334 11.9465 13.3334 11.1998V8.33313M10.3334 3.66646L12.219 5.55208M7.17524 6.82464L11.6074 2.39248C12.1281 1.87178 12.9723 1.87178 13.493 2.39248C14.0137 2.91318 14.0137 3.7574 13.493 4.27809L8.91837 8.85274C8.41061 9.3605 8.15673 9.61438 7.86755 9.81629C7.61087 9.9955 7.33403 10.144 7.04273 10.2586C6.71455 10.3878 6.3626 10.4588 5.6587 10.6008L5.33342 10.6665L5.36505 10.445C5.47699 9.66144 5.53296 9.26965 5.66027 8.90387C5.77325 8.5793 5.92758 8.27063 6.11946 7.98551C6.33569 7.66419 6.61554 7.38434 7.17524 6.82464Z" stroke="#1A6AB3" stroke-linecap="round" stroke-linejoin="round"/>
</svg> <p className="text-[#1A6AB3]">
  تعديل 
  </p></div>
,
              onClick: (row) => navigate(`/admin/users/${row.uuid}/edit`)
            },
            {
              label: <div className="flex items-center gap-2">
                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.4" d="M11.25 0.416992C9.911 0.416992 8.66989 0.68002 7.70508 1.13063C6.89317 1.50984 5.80043 1.75033 4.58333 1.75033C3.90866 1.75033 3.26992 1.67637 2.69496 1.54468C1.81067 1.34214 0.75 1.94818 0.75 2.99297V10.1743C0.75 10.7314 0.83828 11.2558 1.12763 11.6828C1.42683 12.1244 1.88792 12.3857 2.4717 12.5194C3.12299 12.6686 3.83677 12.7503 4.58333 12.7503C5.57314 12.7503 6.50946 12.6066 7.32022 12.3496C7.48565 12.2972 7.56837 12.271 7.60738 12.2089C7.6464 12.1469 7.63093 12.0381 7.60001 11.8205C7.58902 11.7431 7.58333 11.6641 7.58333 11.5837C7.58333 10.6632 8.32953 9.91701 9.25 9.91701L9.25973 9.91706C9.35895 9.91802 9.6011 9.93095 9.84218 10.0077C9.972 10.046 10.109 10.0981 10.2505 10.1674C10.3073 10.1951 10.3356 10.209 10.357 10.2141C10.42 10.2292 10.4744 10.2176 10.5257 10.1781C10.5432 10.1646 10.5613 10.1429 10.5976 10.0994C11.013 9.60153 11.5152 9.05266 12.0653 8.5702C12.5983 8.10276 13.2694 7.61427 14.0269 7.34597C14.1984 7.28523 14.3732 7.25424 14.5457 7.25032C14.8281 7.24389 14.9694 7.24067 15.0264 7.18238C15.0833 7.12409 15.0833 7.00989 15.0833 6.78148V2.99297C15.0833 2.46174 15.0119 1.94001 14.7312 1.50863C14.4383 1.05844 13.973 0.787908 13.3616 0.647878C12.7103 0.498703 11.9966 0.416992 11.25 0.416992Z" fill="#15936E"/>
</svg>
<p className="text-[#15936E]">
    شحن اشتراك المستخدم 
</p>
</div>,
              onClick: (row) => navigate(`/admin/users/${row.uuid}/stop`)
            },
            {
              label: <div className="flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.6667 3.33325H11.3334L10.6667 2.66659H5.33341L4.66675 3.33325H1.33341M12.6667 3.33325V12.6666C12.6667 13.1199 12.5261 13.5559 12.2192 13.8628C11.9123 14.1697 11.4763 14.3103 11.0231 14.3103H4.97608C4.52285 14.3103 4.08686 14.1697 3.77996 13.8628C
3.47307 13.5559 3.33241 13.1199 3.33241 12.6666V3.33325H12.6667Z" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.66675 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M9.33325 7.33325V11.3333" stroke="#E02424" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
 <p className="text-[#E02424]">
    حذف المستخدم
  </p></div>,
  
              onClick: (row) => navigate(`/admin/users/${row.uuid}/delete`)

            }

            ]}
        />
      </div>
    </div>
  );
}